import { ApiServiceBase, DEFAULT_API_OPTIONS } from "./apiServiceBase";

export class UserService extends ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    super({ baseUrl, timeout });
    this._path = "User";
  }

  login(phone, pass) {
    return this._axios.post(`${this._path}/login?phone=${phone}&pass=${pass}`);
  }

  logout() {
    return this._axios.post(`${this._path}/logout`);
  }

  getUser() {
    return this._axios.get(`${this._path}`);
  }

  updateLastSubscribe() {
    return this._axios.post(`${this._path}/subscribe`);
  }

  getMeters() {
    return this._axios.get(`${this._path}/meters`);
  }

  bindMeter(id) {
    return this._axios.post(`${this._path}/meters/${id}`);
  }

  unbindMeter(id) {
    return this._axios.delete(`${this._path}/meters/${id}`);
  }

  setDefaultMeter(id) {
    return this._axios.put(`${this._path}/meters/${id}`);
  }

  updatePhone(phone, pass) {
    return this._axios.post(`${this._path}/phone?phone=${phone}&pass=${pass}`);
  }

  getOrders(page = 1, pageSize = 10) {
    return this._axios.get(`${this._path}/orders?page=${page}&pageSize=${pageSize}`);
  }

  getOrderDetail(orderNo) {
    return this._axios.get(`${this._path}/orders/${orderNo}`);
  }

  bindingEBMS(user, pwd) {
    return this._axios.post(`${this._path}/BindingEBMS?name=${user}&pwd=${pwd}`);
  }

  getPushMessages(page = 1, pageSize = 10) {
    return this._axios.get(`${this._path}/messages?page=${page}&pageSize=${pageSize}`);
  }

}

export const userService = new UserService();
